const endpoints = {
  GenerateGif: `/api/v1/img-to-gif/generate-gif`,
  genearteImageUrl: `/api/v1/s3/file-to-url`,
  saveGif: `/api/v1/img-to-gif/save-gif`,
  deleteGif: `/api/v1/img-to-gif/delete-gif`,
  getUserGifs: `/api/v1/img-to-gif/get-gifs-by-user`,
  getGifs: `/api/v1/img-to-gif/get-all-gifs`,
  updateTitle: `/api/v1/img-to-gif/update-gif-title`,
};
export default endpoints;
